import { createQueryKeys } from '../../factories';

export const DATABUILDER_JOB_NAMESPACE = ['databuilder', 'jobs'];
export const databuilderJobQueryKeyFactory = createQueryKeys(
	DATABUILDER_JOB_NAMESPACE
);
